module.exports = __webpack_public_path__ + "img/流体力学3_5_1.046586d2.jpg";